<template>
  <div>
    <div class="card-content">
      <div class="content">
        <order-status-syncs></order-status-syncs>
      </div>
    </div>
    <div class="card-content">
      <div class="content">
        <order-status-logs></order-status-logs>
      </div>
    </div>
  </div>
</template>

<script>
  import OrderStatusLogs from './OrderStatusLogs'
  import OrderStatusSyncs from './OrderStatusSyncs'
  export default {
    name: 'OrderStatusDetail',
    components: {
      OrderStatusLogs,
      OrderStatusSyncs
    }
  }
</script>

<style scoped>

  >>> table {
    margin: 0px auto;
  }

  >>> th, td {
    padding: 5px;
    border-bottom: 1px solid #ddd;
  }

  >>> th {
    background-color: #DEF0FF;
  }

  >>> table tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  >>> .failed {
    background-color: #FF4A60 !important;
  }

  >>> .buttons {
    margin-top: 10px;
    margin-left: 4px;
  }

</style>
